export default __webpack_public_path__ + "static/ad-45026b922ec57f969a0a19debde23320.svg";